<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Transferências entre contas Safe2Pay</h3>
        </div>
        <!-- Filter -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Transferências</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0">Origem</th>
                    <th scope="col" class="border-0">Destino</th>
                    <th scope="col" class="border-0">Valor</th>
                    <th scope="col" class="border-0">Data da compensação</th>

                    <th scope="col" class="border-0">Enviado</th>
                    <th scope="col" class="border-0">Status</th>
                    <th scope="col" class="border-0">Transferido</th>
                    <th scope="col" class="border-0">Criado por</th>

                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(transfer, index) in transferBankAccounts" :key="index">
                    <td></td>
                    <td class="center td-with-subs">
                      <div>
                        <img
                          v-if="transfer.BankAccountOrigin.Bank.Code == '001'"
                          src="@/assets/images/bank_0001.png"
                          height="32px"
                          width="32px"
                          class="logo"
                          style="text-align: center"
                        />
                        <img
                          v-if="transfer.BankAccountOrigin.Bank.Code == '033'"
                          src="@/assets/images/bank_0033.png"
                          height="32px"
                          width="32px"
                          class="logo"
                          style="text-align: center"
                        />
                        <img
                          v-if="transfer.BankAccountOrigin.Bank.Code == '041'"
                          src="@/assets/images/bank_0041.png"
                          height="32px"
                          width="32px"
                          class="logo"
                          style="text-align: center"
                        />
                        <img
                          v-if="transfer.BankAccountOrigin.Bank.Code == '104'"
                          src="@/assets/images/bank_0104.png"
                          height="32px"
                          width="32px"
                          class="logo"
                          style="text-align: center"
                        />
                        <img
                          v-if="transfer.BankAccountOrigin.Bank.Code == '237'"
                          src="@/assets/images/bank_0237.jpg"
                          height="32px"
                          width="32px"
                          style="text-align: center"
                          class="logo"
                        />
                        <img
                          v-if="transfer.BankAccountOrigin.Bank.Code == '341'"
                          src="@/assets/images/bank_0341.png"
                          height="32px"
                          width="32px"
                          class="logo"
                          style="text-align: center"
                        />
                        <img
                          v-if="transfer.BankAccountOrigin.Bank.Code == '422'"
                          src="@/assets/images/bank_0422.png"
                          height="32px"
                          width="32px"
                          class="logo"
                          style="text-align: center"
                        />
                        <img
                          v-if="transfer.BankAccountOrigin.Bank.Code == '745'"
                          src="@/assets/images/bank_0745.png"
                          height="32px"
                          width="32px"
                          class="logo"
                          style="text-align: center"
                        />
                        <img
                          v-if="transfer.BankAccountOrigin.Bank.Code == '748'"
                          src="@/assets/images/bank_0748.png"
                          height="32px"
                          width="32px"
                          class="logo"
                          style="text-align: center"
                        />
                      </div>
                      <span>
                        {{
                          " Ag: " +
                          transfer.BankAccountOrigin.BankAgency +
                          " CC: " +
                          transfer.BankAccountOrigin.BankAccount
                        }}
                      </span>
                    </td>
                    <td class="center td-with-subs">
                      <div>
                        <img
                          v-if="transfer.BankAccountDestination.Bank.Code == '001'"
                          src="@/assets/images/bank_0001.png"
                          height="32px"
                          width="32px"
                          class="logo"
                          style="text-align: center"
                        />
                        <img
                          v-if="transfer.BankAccountDestination.Bank.Code == '033'"
                          src="@/assets/images/bank_0033.png"
                          height="32px"
                          width="32px"
                          class="logo"
                          style="text-align: center"
                        />
                        <img
                          v-if="transfer.BankAccountDestination.Bank.Code == '041'"
                          src="@/assets/images/bank_0041.png"
                          height="32px"
                          width="32px"
                          class="logo"
                          style="text-align: center"
                        />
                        <img
                          v-if="transfer.BankAccountDestination.Bank.Code == '104'"
                          src="@/assets/images/bank_0104.png"
                          height="32px"
                          width="32px"
                          class="logo"
                          style="text-align: center"
                        />
                        <img
                          v-if="transfer.BankAccountDestination.Bank.Code == '237'"
                          src="@/assets/images/bank_0237.jpg"
                          height="32px"
                          width="32px"
                          class="logo"
                          style="text-align: center"
                        />
                        <img
                          v-if="transfer.BankAccountDestination.Bank.Code == '341'"
                          src="@/assets/images/bank_0341.png"
                          height="32px"
                          width="32px"
                          class="logo"
                          style="text-align: center"
                        />
                        <img
                          v-if="transfer.BankAccountDestination.Bank.Code == '422'"
                          src="@/assets/images/bank_0422.png"
                          height="32px"
                          width="32px"
                          style="text-align: center"
                          class="logo"
                        />
                        <img
                          v-if="transfer.BankAccountDestination.Bank.Code == '745'"
                          src="@/assets/images/bank_0745.png"
                          height="32px"
                          width="32px"
                          style="text-align: center"
                          class="logo"
                        />
                        <img
                          v-if="transfer.BankAccountDestination.Bank.Code == '748'"
                          src="@/assets/images/bank_0748.png"
                          height="32px"
                          width="32px"
                          style="text-align: center"
                          class="logo"
                        />
                      </div>
                      <span>
                        {{
                          " Ag: " +
                          transfer.BankAccountDestination.BankAgency +
                          " CC: " +
                          transfer.BankAccountDestination.BankAccount
                        }}
                      </span>
                    </td>

                    <td>{{ transfer.Amount | currency }}</td>
                    <td>{{ transfer.CompensationDate | date }}</td>

                    <td v-if="transfer.TransferRegister.IdTransfer > 0"><i class="fas fa-check fa-green" /></td>
                    <td v-else><i class="fas fa-times fa-red" /></td>

                    <td>{{ transfer.TransferRegister.PaymentStatus }}</td>

                    <td v-if="transfer.TransferRegister.IsTransferred"><i class="fas fa-check fa-green" /></td>
                    <td v-else><i class="fas fa-times fa-red" /></td>

                    <td class="center td-with-subs">
                      <div>
                        {{ transfer.UserInternal.Name }}
                      </div>
                      <span>
                        {{ transfer.CreatedDate | date }}
                        {{ transfer.CreatedDate | date("HH:mm:ss") }}
                      </span>
                    </td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          :class="loadingStatus ? 'disabled' : ''"
                          :disabled="transfer.TransferRegister.IdTransfer > 0"
                        >
                          Opções
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            v-if="
                              $isAuthorize('TransferBankAccounts', 'Update') && transfer.TransferRegister.IdTransfer == 0
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenTransferBankAccounts($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="
                              $isAuthorize('TransferBankAccounts', 'GenerateRemittance') &&
                              transfer.TransferRegister.IdTransfer == 0
                            "
                            class="dropdown-item"
                            href="#"
                            :class="loadingStatus ? 'disabled' : ''"
                            v-on:click="GenerateRemittance($event, index)"
                          >
                            <template v-if="loadingStatus">
                              <loader :small="true" :isLoading="loadingStatus"></loader>
                            </template>
                            <template v-else> <i class="fas fa-share-square"></i> Enviar remessa</template>
                          </a>
                          <a
                            v-if="
                              $isAuthorize('TransferBankAccounts', 'Delete') && transfer.TransferRegister.IdTransfer == 0
                            "
                            class="dropdown-item"
                            href="#"
                            :class="loadingStatus ? 'disabled' : ''"
                            v-on:click="ConfirmDeleteTransferBankAccounts($event, index)"
                          >
                            <template v-if="loadingStatus">
                              <loader :small="true" :isLoading="loadingStatus"></loader>
                            </template>
                            <template v-else> <i class="fas fa-trash-alt mr-2"></i> Remover </template>
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      transferBankAccounts == null ||
                      transferBankAccounts == undefined ||
                      transferBankAccounts.length == 0
                    "
                  >
                    <td colspan="11">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormTransferBankAccount"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <loader :is-loading="loadingModal"></loader>

      <div v-if="!loadingModal">
        <ValidationObserver tag="form" ref="Area2ValidationForm">
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Conta bancária de origem</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  :class="validatedArea2Form | showValidateError(invalid)"
                  v-model="infoTransferBankAccount.BankAccountOrigin.Code"
                  :disabled="isSeeing"
                >
                  <option :value="null">Selecione</option>
                  <option v-for="type in bankAccountsOrigin" v-bind:key="type.Code" v-bind:value="type.Code">
                    {{ type.Bank.Name + " Ag: " + type.BankAgency + " CC: " + type.BankAccount }}
                  </option>
                </d-select>
                <div class="invalid-feedback d-block" v-if="validatedArea2Form">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Conta bancária de destino</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  :class="validatedArea2Form | showValidateError(invalid)"
                  v-model="infoTransferBankAccount.BankAccountDestination.Code"
                  :disabled="isSeeing"
                >
                  <option :value="null">Selecione</option>
                  <option v-for="type in bankAccountsDestination" v-bind:key="type.Code" v-bind:value="type.Code">
                    {{ type.Bank.Name + " Ag: " + type.BankAgency + " CC: " + type.BankAccount }}
                  </option>
                </d-select>
                <div class="invalid-feedback d-block" v-if="validatedArea2Form">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Valor</label>
              <ValidationProvider rules="required|min_value:0.01" v-slot="{ errors, invalid }">
                <currency-input
                  class="form-control"
                  :class="validatedArea2Form | showValidateError(invalid)"
                  v-model="infoTransferBankAccount.Amount"
                  :disabled="isSeeing"
                />
                <div class="invalid-feedback d-block" v-if="validatedArea2Form">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label>Data da compensação</label>
              <date-field :disabled="isSeeing" v-model="infoTransferBankAccount.CompensationDate" />
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveTransferBankAccount()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal id="mFilter" title="Filtros" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-form-row>
        <d-col v-if="!isSeeing" md="12" class="form-group">
          <label>Conta bancária de origem</label>

          <d-select v-model="filter.BankAccountOrigin.Code">
            <option :value="null">Selecione</option>
            <option v-for="type in bankAccountsOrigin" v-bind:key="type.Code" v-bind:value="type.Code">
              {{ type.Bank.Name + " Ag: " + type.BankAgency + " CC: " + type.BankAccount }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col v-if="!isSeeing" md="12" class="form-group">
          <label>Conta bancária de destino</label>

          <d-select v-model="filter.BankAccountDestination.Code">
            <option :value="null">Selecione</option>
            <option v-for="type in bankAccountsDestination" v-bind:key="type.Code" v-bind:value="type.Code">
              {{ type.Bank.Name + " Ag: " + type.BankAgency + " CC: " + type.BankAccount }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button variant="primary" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar" @click="Filter()">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('TransferBankAccounts', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Nova transferência"
      v-on:click="OpenTransferBankAccounts($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "../common/date-field";
export default {
  name: "transferRegister",
  components: { dateField },
  data: function () {
    return {
      filter: {
        BankAccountOrigin: { Code: null },
        BankAccountDestination: { Code: null },
      },
      transferBankAccounts: [],
      bankAccountsOrigin: [],
      bankAccountsDestination: [],
      loadingStatus: null,

      infoTransferBankAccount: {
        BankAccountOrigin: {
          Code: null,
        },
        BankAccountDestination: {
          Code: null,
        },
        UserInternal: {},
        Amount: null,
        CompensationDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
      },
      countFilter: 0,
      idTransferBankAccounts: 0,
      loadingModal: false,
      isSeeing: false,
      isCreating: false,
      loadingList: false,
      loadingAddUpdate: false,
      modalTitle: "Detalhe da Transferência Bancária entre contas",
      labelOrigin: "Conta de Origem",
      labelDestination: "Conta de Destino",
      labelAmount: "Valor",
      labelIsReleaseTransfer: "Liberado",
      labelIsTransferred: "Transferido",
      labelCreatedDate: "Data de Criação",
      labelCompensationDate: "Data de Compensação",
      labelStatusPayment: "Status do Pagamento",
      listPending: false,
      loadingReport: false,
      loadingDownload: false,
      loadingTransferRegister: false,
      loadingUpdate: false,
      pOpened: null,
      validatedArea2Form: false,

      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
    };
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListTransferBankAccounts();
    },
    "pagination.RowsPerPage": function () {
      this.ListTransferBankAccounts();
    },
  },
  mounted() {
    this.ListTransferBankAccounts();
    this.ListBankAccounts(true);
    this.ListBankAccounts(false);
  },
  methods: {
    SaveTransferBankAccount: function () {
      this.validatedArea2Form = true;
      this.$refs.Area2ValidationForm.validate().then((isValid) => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;
          if (this.pOpened == null) {
            // Add
            this.$store
              .dispatch("AddTransferBankAccount", this.infoTransferBankAccount)
              .then(() => {
                this.$makeToast(
                  "A transferência foi cadastrada corretamente na base de dados",
                  "success",
                  "Transferência bancária entre contas"
                );
                this.ListTransferBankAccounts();
                this.$bvModal.hide("mFormTransferBankAccount");
              })
              .catch((error) => {
                this.$makeToast(undefined, "danger", "Erro ao criar a transferência", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.$store
              .dispatch("UpdateTransferBankAccount", this.infoTransferBankAccount)
              .then(() => {
                this.$makeToast(
                  "Suas modificações foram salvas na base de dados",
                  "success",
                  "Transferência bancária entre contas"
                );
                this.ListTransferBankAccounts();
                this.$bvModal.hide("mFormTransferBankAccount");
              })
              .catch((error) => {
                this.$makeToast(undefined, "danger", "Erro ao criar a transferência", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetTransferBankAccounts: function () {
      if (this.idTransferBankAccounts != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetTransferBankAccounts", { id: this.idTransferBankAccounts })
          .then((response) => {
            this.infoTransferBankAccount = response;
            console.log(this.infoTransferBankAccount);
          })
          .catch((error) => {
            this.$makeToast(undefined, "danger", "Erro ao buscar a transferência", error);
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ConfirmDeleteTransferBankAccounts: function (e, i) {
      e.preventDefault();
      this.$makeMsgBox(`Você tem certeza que deseja remover?`, "Confirmar", this.DeleteTransferBankAccounts, i);
    },
    GenerateRemittance: function (e, i) {
      e.preventDefault();
      this.$makeMsgBox(
        `Você tem certeza que deseja enviar a remessa?`,
        "Confirmar",
        this.GenerateRemittanceTransferBankAccounts,
        i
      );
    },
    GenerateRemittanceTransferBankAccounts: function (i) {
      let generate = this.transferBankAccounts[i];
      this.loadingStatus = true;
      this.$store
        .dispatch("GenerateRemittanceTransferBankAccounts", { id: generate.Id })
        .then(() => {
          this.$makeToast(`Arquivo de pagamento enviado com sucesso`, "success", "Transferência entre contas");
          this.ListTransferBankAccounts();
          this.$bvModal.hide("mFormTransferBankAccount");
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao enviar arquivo de pagamento", error);
        });
    },
    DeleteTransferBankAccounts: function (i) {
      let deleted = this.transferBankAccounts[i];
      this.$store
        .dispatch("DeleteTransferBankAccounts", { id: deleted.Id })
        .then(() => {
          this.$makeToast(`A transferência foi removida da sua lista`, "success", "Transferência entre contas");
          this.ListTransferBankAccounts();
          this.$bvModal.hide("mFormTransferBankAccount");
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao remover a transferência", error);
        });
    },
    OpenTransferBankAccounts: function (e, i, view) {
      e.preventDefault();
      this.loadingAddUpdate = false;
      this.validatedArea2Form = false;
      this.ResetTransferBankAccounts();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idTransferBankAccounts = this.transferBankAccounts[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar transferência";
        this.GetTransferBankAccounts();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Nova transferência";
        //
      } else {
        // View
        this.pOpened = i;
        this.idTransferBankAccounts = this.transferBankAccounts[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes da transferência";
        this.GetTransferBankAccounts();
      }
      this.$bvModal.show("mFormTransferBankAccount");
    },
    ResetTransferBankAccounts: function () {
      this.idTransferBankAccounts = 0;
      this.infoTransferBankAccount = {
        BankAccountOrigin: {
          Code: null,
        },
        BankAccountDestination: {
          Code: null,
        },
        Amount: null,
        CompensationDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
      };
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    HideModal: function () {
      this.$bvModal.hide("mFormTransferBankAccount");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListTransferBankAccounts();
    },
    ResetFilter: function () {
      this.filter = {
        BankAccountOrigin: { Code: null },
        BankAccountDestination: { Code: null },
      };
      this.ListTransferBankAccounts();
    },
    ListBankAccounts: function (isEnabledPaymentFile) {
      let data = {
        "Object.IsEnabledPaymentFile": isEnabledPaymentFile,
      };
      this.$store
        .dispatch("ListBankAccountsS2P", { params: data })
        .then((response) => {
          if (isEnabledPaymentFile) this.bankAccountsOrigin = response;
          else this.bankAccountsDestination = response;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de tipos de transferências", error);
        });
    },
    ListTransferBankAccounts: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.BankAccountOrigin.Code)) this.countFilter++;
      if (hasValue(this.filter.BankAccountDestination.Code)) this.countFilter++;

      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.BankAccountOrigin.Code": this.filter.BankAccountOrigin.Code,
          "Object.BankAccountDestination.Code": this.filter.BankAccountDestination.Code,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListTransferBankAccounts", { params: data })
        .then(
          (response) => {
            this.transferBankAccounts = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          },
          (error) => {
            this.$makeToast("Não foi possível as transferências bancárias", "danger", "Transferências bancárias", error);
          }
        )
        .finally(() => {
          this.loadingList = false;
        });
    },
  },
};
</script>


<style scoped>
.fa-green {
  color: #0ac37f;
}
.fa-red {
  color: #ff0000;
}

.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.td-span-style {
  font-size: 9pt;
  opacity: 0.75;
}
.tr-hidden {
  border-top: hidden;
}
.fa-red {
  color: #ff0000;
}
.nav-steps .breadcrumb-item:before {
  content: none;
}
.nav-steps .breadcrumb-item .active {
  text-decoration: underline;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/transferBankAccounts.vue